import Router from 'vue-router'
import {storage} from '@/utils/storage'
import {getUserInfoByToken} from '@/api'
import { Loading } from 'element-ui'
import HOST from '@/config/ENV'
import routerConfig from '@/config/routerConfig'
console.log( routerConfig, '加载配置文件1：' )
const getComponent = page => () => import(`@/components/${page}`)
const getPage = (modules, page = 'index') => () => import(`@/views/${modules}/pages/${page}`)

const allRoutes = [
  {
    path: '/',
    redirect: 'login'
  },
  {
    path: 'layout',
    component: getComponent('layout'),
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {
          requiresAuth: true
        },
        component: getPage('home')
      },
      {
        path: '/consultation',
        name: 'consultation',
        component: getPage('consultation')
      },
      {
        path: '/consultationFrom/:id',
        name: 'consultationFrom',
        component: getPage('consultation', 'from'),
        props: (route) => ({
          id: route.params.id
        })
      },
      {
        path: '/test', // 测试测试测试测试测试测试测试测试测试测试测试测试测试
        name: 'test',
        meta: {
          requiresAuth: true
        },
        component: getPage('test')
      },
      {
        path: '/test/:id', // 测试测试测试测试测试测试测试测试测试测试测试测试测试表单
        name: 'testForm',
        meta: {
          group: 'test',
          requiresAuth: true
        },
        component: getPage('test', 'form')
      },
      {
        path: '/produceManage', // 农产品管理列表
        name: 'produceManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('produceManage')
      },
      {
        path: '/produceManage/:id', // 农产品管理列表表单
        name: 'produceManageForm',
        meta: {
          group: 'produceManage',
          requiresAuth: true
        },
        component: getPage('produceManage', 'form')
      },
      {
        path: '/RestudentManage',
        name: 'RestudentManage',
        meta: {
          group: 'produceManage',
          requiresAuth: true
        },
        component: getPage('RestudentManage')
      },
      {
        path: '/RestudentManageForm/:id',
        name: 'RestudentManageForm',
        meta: {
          group: 'produceManage',
          requiresAuth: true
        },
        component: getPage('RestudentManage', 'form')
      },
      {
        path: '/produceTypeManage', // 农产品类型管理
        name: 'produceTypeManage',
        meta: {
          group: 'produceTypeManage',
          requiresAuth: true
        },
        component: getPage('produceTypeManage')
      },
      {
        path: '/produceTypeManage/:id', // 农产品类型表单
        name: 'produceTypeManageForm',
        meta: {
          group: 'produceTypeManage',
          requiresAuth: true
        },
        component: getPage('produceTypeManage', 'form')
      },
      {
        path: '/hotelManage', // 酒店管理列表
        name: 'hotelManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('hotelManage')
      },
      {
        path: '/hotelManageForm/:id', // 酒店管理列表表单
        name: 'hotelManageForm',
        meta: {
          group: 'hotelManage',
          requiresAuth: true
        },
        component: getPage('hotelManage', 'form')
      },
      {
        path: '/screenHenSan', // 大屏管理 - 横山
        name: 'screenHenSan',
        meta: {
          group: 'screenManage',
          module: 'summary'
        },
        component: getPage('screenManage', 'hensan')
      },
      {
        path: '/screenTravel',
        name: 'screenTravel',
        meta: {
          group: 'screenManage',
          module: 'travel'
        },
        component: getPage('screenManage', 'travel')
      },
      {
        path: '/screenDoctor',
        name: 'screenDoctor',
        meta: {
          group: 'screenManage',
          module: 'health'
        },
        component: getPage('screenManage', 'doctor')
      },
      {
        path: '/screenSport',
        name: 'screenSport',
        meta: {
          group: 'screenManage',
          module: 'sports'
        },
        component: getPage('screenManage', 'sport')
      },
      {
        path: '/screenBeauty',
        name: 'screenBeauty',
        meta: {
          group: 'screenManage',
          module: 'product'
        },
        component: getPage('screenManage', 'beauty')
      },
      {
        path: '/screenTeamBuild',
        name: 'screenTeamBuild',
        meta: {
          group: 'screenManage',
          module: 'team'
        },
        component: getPage('screenManage', 'team')
      },
      {
        path: '/settingModule',
        name: 'settingModule',
        component: getPage('setting', 'module')
      },
      {
        path: '/settingModule/:id',
        name: 'settingModuleFrom',
        component: getPage('setting', 'from'),
        props: (route) => ({
          id: route.params.id
        })
      },
        {
        path: '/medicalProjectManage', // 特色诊疗列表
        name: 'medicalProjectManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('medicalProjectManage')
      },
      {
        path: '/medicalProjectManageForm/:id', // 特色诊疗列表表单
        name: 'medicalProjectManageForm',
        meta: {
          group: 'medicalProjectManage',
          requiresAuth: true
        },
        component: getPage('medicalProjectManage', 'form')
      },
      {
        path: '/MedicalEquipmentManage', // 健康智能产品管理
        name: 'MedicalEquipmentManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('medicalEquipmentManage')
      },
      {
        path: '/MedicalEquipmentManageForm/:id', // 健康智能产品列表表单
        name: 'MedicalEquipmentManageForm',
        meta: {
          group: 'MedicalEquipmentManage',
          requiresAuth: true
        },
        component: getPage('medicalEquipmentManage', 'form')
      },
      {
        path: '/ServerEquipmentManage', // 服务产品管理
        name: 'ServerEquipmentManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('serverEquipmentManage')
      },
      {
        path: '/ServerEquipmentManageForm/:id', // 健康智能产品列表表单
        name: 'ServerEquipmentManageForm',
        meta: {
          group: 'ServerEquipmentManage',
          requiresAuth: true
        },
        component: getPage('serverEquipmentManage', 'form')
      },
      {
        path: '/equipmentTypeManage', // 设备类型管理
        name: 'EquipmentTypeManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('equipmentTypeManage')
      },
      {
        path: '/equipmentTypeManageForm/:id', // 设备类型管理
        name: 'EquipmentTypeManageForm',
        meta: {
          group: 'EquipmentTypeManage',
          requiresAuth: true
        },
        component: getPage('equipmentTypeManage', 'form')
      },
      {
        path: '/IntellectEquipmentManage', // 健康智能产品管理
        name: 'IntellectEquipmentManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('medicalEquipmentManage')
      },
      {
        path: '/IntellectEquipmentManageForm/:id', // 健康智能产品列表表单
        name: 'IntellectEquipmentManageForm',
        meta: {
          group: 'IntellectEquipmentManage',
          requiresAuth: true
        },
        component: getPage('medicalEquipmentManage', 'form')
      },
      {
        path: '/medicalCaseManage', // 相关案例管理
        name: 'medicalCaseManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('medicalCaseManage')
      },
      {
        path: '/medicalCaseManageForm/:id', // 相关案例列表表单
        name: 'medicalCaseManageForm',
        meta: {
          group: 'medicalCaseManage',
          requiresAuth: true
        },
        component: getPage('medicalCaseManage', 'form')
      },
      {
        path: '/tourActivityManage', // 旅游活动管理
        name: 'tourActivityManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('tourActivityManage')
      },
      {
        path: '/tourActivityManageForm/:id', // 旅游活动列表表单
        name: 'tourActivityManageForm',
        meta: {
          group: 'tourActivityManage',
          requiresAuth: true
        },
        component: getPage('tourActivityManage', 'form')
      },
      {
        path: '/sportEquipmentManage', // 运动设备管理
        name: 'sportEquipmentManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('sportEquipmentManage')
      },
      {
        path: '/sportEquipmentManageForm/:id', // 运动设备列表表单
        name: 'sportEquipmentManageForm',
        meta: {
          group: 'sportEquipmentManage',
          requiresAuth: true
        },
        component: getPage('sportEquipmentManage', 'form')
      },
      {
        path: '/staffManage',
        name: 'staffManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('staffManage')
      },
      {
        path: '/staffForm/:id',
        name: 'staffForm',
        meta: {
          group: 'staffManage',
          requiresAuth: true
        },
        component: getPage('staffManage', 'form')
      },
      {
        path: '/tourManage',
        name: 'tourManage',
        meta: {
          requiresAuth: true
        },
        component: getPage( 'tourManage' )
      },
      {
        path: '/tourManageForm/:id',
        name: 'tourManageForm',
        meta: {
          group: 'tourManage',
          requiresAuth: true
        },
        component: getPage( 'tourManage', 'form' )
      },
      {
        path: '/sportActivityManage',
        name: 'sportActivityManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('sportActivityManage')
      },
      {
        path: '/sportActivityManageForm/:id',
        name: 'sportActivityManageForm',
        meta: {
          group: 'sportActivityManage',
          requiresAuth: true
        },
        component: getPage('sportActivityManage', 'form')
      },
      {
        path: '/farmerManage',
        name: 'farmerManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('farmerManage')
      },
      {
        path: '/farmerForm/:id',
        name: 'farmerForm',
        meta: {
          group: 'farmerManage',
          requiresAuth: true
        },
        component: getPage('farmerManage', 'form')
      },
      {
        path: '/serviceStaff',
        name: 'serviceStaff',
        meta: {
          requiresAuth: true
        },
        component: getPage( 'serviceStaff' )
      },
      {
        path: '/voluntForm/:id',
        name: 'voluntForm',
        meta: {
          group: 'serviceStaff',
          requiresAuth: true
        },
        component: getPage( 'serviceStaff', 'form' )
      },
      {
        path: '/postulant',
        name: 'postulant',
        meta: {
          requiresAuth: true
        },
        component: getPage( 'postulant' )
      },
      {
        path: '/postulantForm/:id',
        name: 'postulantForm',
        meta: {
          group: 'postulant',
          requiresAuth: true
        },
        component: getPage( 'postulant', 'form' )
      }, {
        path: '/appointment',
        name: 'appointment',
        meta: {
          requiresAuth: true
        },
        component: getPage( 'appointment' )
      },
      {
        path: '/appointmentForm/:id',
        name: 'appointmentForm',
        meta: {
          group: 'appointment',
          requiresAuth: true
        },
        component: getPage( 'appointment', 'form' )
      },
      {
        path: '/orgManage',
        name: 'orgManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('orgManage')
      },
      {
        path: '/orgManageForm/:id',
        name: 'orgManageForm',
        meta: {
          group: 'orgManage',
          requiresAuth: true
        },
        component: getPage('orgManage', 'form')
      },
      {
        path: '/dictionaryConfig',
        name: 'dictionaryConfig',
        meta: {
          requiresAuth: true
        },
        component: getPage('dictManage')
      },
      {
        path: '/dictForm/:id',
        name: 'dictForm',
        meta: {
          group: 'dictManage',
          requiresAuth: true
        },
        component: getPage('dictManage', 'form')
      },
      {
        path: '/RoleManage',
        name: 'RoleManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('roleManage')
      },
      {
        path: '/RoleManageForm/:id',
        name: 'RoleManageForm',
        meta: {
          group: 'RoleManage',
          requiresAuth: true
        },
        component: getPage('roleManage', 'form')
      },
      {
        path: '/permissionManage',
        name: 'permissionManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('permissionManage')
      },
      {
        path: '/permissionManageForm/:id',
        name: 'permissionManageForm',
        meta: {
          group: 'permissionManage',
          requiresAuth: true
        },
        component: getPage('permissionManage', 'form')
      },
      {
        path: '/commentPeople',
        name: 'commentPeople',
        meta: {
          requiresAuth: true
        },
        component: getPage('commentPeople')
      },
      {
        path: '/commentPeopleForm/:id',
        name: 'commentPeopleForm',
        meta: {
          group: 'commentPeople',
          requiresAuth: true
        },
        component: getPage('commentPeople', 'form')
      },
      {
        path: '/serviceComplaints/:status',
        name: 'serviceComplaints',
        meta: {
          requiresAuth: true
        },
        component: getPage('serviceComplaints')
      },
      {
        path: '/serviceComplaintsForm/:status/:id',
        name: 'serviceComplaintsForm',
        meta: {
          group: 'serviceComplaints',
          requiresAuth: true
        },
        component: getPage('serviceComplaints', 'form')
      },
      {
        path: '/adminManage',
        name: 'adminManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('adminManage')
      },
      {
        path: '/adminManageForm/:id',
        name: 'adminManageForm',
        meta: {
          group: 'adminManage',
          requiresAuth: true
        },
        component: getPage('adminManage', 'form')
      },
      {
        path: '/adminManageVolunteer',
        name: 'adminManageVolunteer',
        meta: {
          requiresAuth: true
        },
        component: getPage('adminManageVolunteer')
      },
      {
        path: '/scenicAreaManage',
        name: 'scenicAreaManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('scenicAreaManage')
      },
      {
        path: '/scenicAreaManageForm/:id',
        name: 'scenicAreaManageForm',
        meta: {
          group: 'scenicAreaManage',
          requiresAuth: true
        },
        component: getPage('scenicAreaManage', 'form')
      },
      {
        path: '/ticketManage',
        name: 'ticketManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('ticketManage')
      },
      {
        path: '/ticketManageForm/:id',
        name: 'ticketManageForm',
        meta: {
          group: 'ticketManage',
          requiresAuth: true
        },
        component: getPage('ticketManage', 'form')
      },
      {
        path: '/bedManage',
        name: 'bedManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('bedManage')
      },
      {
        path: '/bedManageForm/:id',
        name: 'bedManageForm',
        meta: {
          group: 'bedManage',
          requiresAuth: true
        },
        component: getPage('bedManage', 'form')
      },
      {
        path: '/trainManage',
        name: 'trainManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('trainManage')
      },
      {
        path: '/trainManageForm/:id',
        name: 'trainManageForm',
        meta: {
          group: 'trainManage',
          requiresAuth: true
        },
        component: getPage('trainManage', 'form')
      },
      {
        path: '/appraisalManage',
        name: 'appraisalManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('appraisalManage')
      },
      {
        path: '/appraisalManageForm/:id',
        name: 'appraisalManageForm',
        meta: {
          group: 'appraisalManage',
          requiresAuth: true
        },
        component: getPage('appraisalManage', 'form')
      },
      {
        path: '/weatherManage',
        name: 'weatherManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('weatherManage')
      },
      {
        path: '/weatherManageForm/:id',
        name: 'weatherManageForm',
        meta: {
          group: 'weatherManage',
          requiresAuth: true
        },
        component: getPage('weatherManage', 'form')
      },
      {
        path: '/commentManage',
        name: 'commentManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('commentManage')
      },
      {
        path: '/commentManageForm/:id',
        name: 'commentManageForm',
        meta: {
          group: 'commentManage',
          requiresAuth: true
        },
        component: getPage('commentManage', 'form')
      },
      {
        path: '/objBeatifulManage',
        name: 'objBeatifulManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('objBeatifulManage')
      },
      {
        path: '/IntroduceMedicineManage',
        name: 'IntroduceMedicineManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('IntroduceMedicineManage')
      },
      {
        path: '/IntroduceSiteManage',
        name: 'IntroduceSiteManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('IntroduceSiteManage')
      },
      {
        path: '/messageManage',
        name: 'MessageManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('messageManage')
      },
      {
        path: '/messageManageForm/:id',
        name: 'MessageManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('messageManage', 'form')
      },
      {
        path: '/houseManage',
        name: 'HouseManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('houseManage')
      },
      {
        path: '/houseManageForm/:id',
        name: 'HouseManage',
        meta: {
          requiresAuth: true
        },
        component: getPage('houseManage','form')
      },
      {
        path: '/serverTypeManage',
        name: 'ServerTypeManage',
        meta: {
          requiresAuth: true
        },
        component: getPage( 'serverTypeManage' )
      },
      {
        path: '/serverTypeManageForm/:id',
        name: 'ServerTypeManageForm',
        meta: {
          group: 'ServerTypeManage',
          requiresAuth: true
        },
        component: getPage('serverTypeManage', 'form' )
      },
      {
        path: '/serverProductManage',
        name: 'serverProductManage',
        meta: {
          requiresAuth: true
        },
        component: getPage( 'serverProductManage' )
      },
      {
        path: '/serverProductManageForm/:id',
        name: 'serverProductManageForm',
        meta: {
          group: 'serverProductManage',
          requiresAuth: true
        },
        component: getPage( 'serverProductManage', 'form' )
      },
      {
        path: '/town',
        name: 'town',
        meta: {
          requiresAuth: true
        },
        component: getPage('town')
      },
      {
        path: '/orgStaffMap',
        name: 'orgStaffMap',
        meta: {
          requiresAuth: true
        },
        component: getPage( 'peoplePosition' )
    },
    {
      path: '/oldDataManage',
      name: 'oldDataManage',
      meta: {
        requiresAuth: true
      },
      component: getPage( 'oldDataManage' )
    },
    {
      path: '/oldDataManageForm/:id',
      name: 'oldDataManageForm',
      meta: {
        group: 'oldDataManage',
        requiresAuth: true
      },
      component: getPage( 'oldDataManage', 'form' )
    }
    ]
  },
  {
    path: '/login',
    component: getPage('login')
  }
]

// const singleSignOn = false // 控制是否启用单点登录
// const singleSignUrl = 'http://www.hk952183.com:40809/#/login' // 单点登录去往养老系统的登录页地址
// const callbackUrl = 'http://118.24.54.72/#/home' // 单点登录成功后回到本系统的首页
// export const VolunteerHomeUrl = 'http://www.hk952183.com:40809/#/home' // 志愿者系统首页
// const singleSignUrl = 'http://localhost:8083/#/login'
// const callbackUrl = 'http://localhost:8089/#/home'
// export const VolunteerHomeUrl = 'http://localhost:8083/#/home'

const singleSignOn = HOST.singleSignOn // 控制是否启用单点登录
const singleSignUrl = HOST.singleSignUrl // 单点登录去往养老系统的登录页地址
const callbackUrl = HOST.callbackUrl // 单点登录成功后回到本系统的首页
export const VolunteerHomeUrl = HOST.VolunteerHomeUrl // 志愿者系统首页

export function createRouter (Vue) {
  Vue.use(Router)
  const router = new Router({
    // mode: 'history',
    routes: allRoutes
  })
  // 针对单点登录进行路由拦截
  router.beforeEach(async (to, from, next) => {
    console.log(to, from)
    // 拿到当前用户在浏览器中的信息，没有token且启用单点登录，则跳转到养老系统去登录拿token
    let userinfo = storage.get('userinfo') || {}
    // 这里有可能是养老系统登录后通过callback并携带token跳回来，需要拿到token避免下面再去重复跳养老
    const tokenIndex = to.fullPath.indexOf('token')
    if (tokenIndex !== -1) {
      let loadingInstance = Loading.service({ fullscreen: true })
      const token = to.fullPath.substring(tokenIndex + 6)
      // 根据养老系统返回的token去查本系统用户信息和本系统对应的token
      // JSON.parse，不要直接赋值
      storage.set('userinfo', {token: token})
      const result = await getUserInfoByToken({
        params: {
          token: token
        }
      })
      storage.set('userinfo', result.payload)
      userinfo = storage.get('userinfo')
      loadingInstance.close()
    }
    console.log(userinfo)
    // 启用单点登录但是没有token
    if (singleSignOn && !userinfo.token) {
      // 退出登录时清空token，跳到志愿者系统时告诉志愿者系统也要清空token
      const tokenError = storage.get('tokenError')
      storage.set('tokenError', false)
      window.location.href = tokenError ? `${singleSignUrl}?callback=${callbackUrl}&tokenError=true` : `${singleSignUrl}?callback=${callbackUrl}`
      return
    }
    // 启用单点，有token并且准备去login页，直接进home
    if (singleSignOn && userinfo.token && to.path.indexOf('login') !== -1) {
      next('/home')
      return
    }
    console.log(routerConfig, to, '加载配置文件2：')
    // 设置xpage
    function setXpage( routerConfig ) {
      routerConfig.forEach(router => {
        let target = to.path.split('/')
        if (router.path && router.path.indexOf(target[1]) != -1) {
          storage.set('X-Page', router.permissionUrl)
        } else {
          if ( router.submenu ) {
            setXpage( router.submenu )
          }
        }
      })
    }
    setXpage( routerConfig )
    next()
  })
  return router
}



// WEBPACK FOOTER //
// ./src/router/index.js